<ngx-skeleton-loader
    [animation]="animation ?? 'progress-dark'"
    [count]="count ?? 1"
    [theme]="{
        'border-radius': '0.5rem',
        'height': height,
        'width': width ?? '100%',
        'margin': margin ?? '0',
        'background-color': 'var(--ion-color-light)'
    }"
    [appearance]="appearance ?? 'line'"
    [attr.aria-label]="ariaLabel"></ngx-skeleton-loader>
